var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outside-link",on:{"click":_vm.addAgent}},[_c('div',{staticClass:"outside-link__content"},[_vm._v("Вступить в партнерскую программу")])])
}
var staticRenderFns = []

export { render, staticRenderFns }